import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    AlphaBatchEntityObjectBaseComponent
} from "../component/object-components/alpha-batch-entity-object-base-component/alpha-batch-entity-object-base.component";
import {
    AlphaBatchEntitySideComponent
} from "../component/object-components/alpha-batch-entity-object-base-component/view/alpha-batch-entity-side-component/alpha-batch-entity-side.component";
import {
    AlphaBatchEntityFullComponent
} from "../component/object-components/alpha-batch-entity-object-base-component/view/alpha-batch-entity-full-component/alpha-batch-entity-full.component";


const haModuleEntry: TestModuleDefinition = {
    key: 'ha',
    label: 'Integration Alpha (ha)',
    components: [
        {
            key: 'AlphaBatchEntityObjectBaseComponent',
            component: AlphaBatchEntityObjectBaseComponent,
            selector: 'alpha-batch-entity-object-base-component',
            type: 'ObjectBaseComponent',
            label: 'alpha batch entity object base component'
        },
        {
            key: 'AlphaBatchEntitySideComponent',
            component: AlphaBatchEntitySideComponent,
            selector: 'alpha-batch-entity-side-component',
            type: 'AlphaBatchEntityBaseComponent',
            label: 'alpha batch entity side component'
        },
        {
            key: 'AlphaBatchEntityFullComponent',
            component: AlphaBatchEntityFullComponent,
            selector: 'alpha-batch-entity-full-component',
            type: 'AlphaBatchEntityBaseComponent',
            label: 'alpha batch entity full component'
        }
    ]
}

export const HA_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: haModuleEntry, multi: true}
];